import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  getEntries, fetchAll, clearAll, setViewType, setGrouping
} from 'profile/ducks/name_entries';
import Entries from 'profile/components/your_entries/entries';
import { NAME_ENTRIES_RESOURCE_NAME } from 'profile/constants';

const mapStateToProps = (state) => {
  const { viewType, grouped, isFetching } = state.profile.nameEntries;

  return {
    resourceName: NAME_ENTRIES_RESOURCE_NAME,
    entryType: 'name',
    entries: getEntries(state),
    user: state.user.profile_data,
    loading: isFetching,
    viewType,
    grouped
  };
}

export default withRouter(connect(mapStateToProps, {
  fetch: fetchAll,
  clear: clearAll,
  setViewType,
  setGrouping
})(Entries));



// WEBPACK FOOTER //
// ./profile/containers/your_entries/name_entries.js